import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const ButtonSpinner = styled.span`
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;

const sizeStyles = {
  small: { height: "24px", padding: "2px 8px", fontSize: "12px" },
  default: { height: "32px", padding: "4px 16px", fontSize: "14px" },
  big: { height: "40px", padding: "6px 24px", fontSize: "16px" },
};

const variantStyles = {
  primary: {
    background: "var(--Primary-Blue, #2060EA)",
    color: "#ffffff",
  },
  primaryLight: {
    background: "var(--MIST, #F7F8F9)",
    color: "var(--BLUE, #2060EA);",
  },
  secondary: {
    background: "var(--Secondary-Gray, #F7F8F9)",
    color: "var(--Primary-Blue, #4a4a68)",
  },
  danger: {
    background: "var(--Danger, #CF324A)",
    color: "var(--Cloud, #FCFDFE)",
  },
};

// helper to turn numbers into px
const toPx = v => (typeof v === "number" ? `${v}px` : v);

export const StyledButtonT1 = styled.button`
  align-items: center;
  border: unset;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  gap: 8px; /* space between spinner and text */

  /* variant-based bg & text colors, with bg override */
  background: ${props =>
    props.$bg != null ? props.$bg : variantStyles[props.$variant || "primary"].background};
  color: ${props =>
    props.$color != null ? props.$color : variantStyles[props.$variant || "primary"].color};

  /* border-radius override or default */
  border-radius: ${props => toPx(props.$borderRadius || 4)};

  /* optional fixed width */
  ${props => props.$width != null && `width: ${toPx(props.$width)};`}

  /* height override or size preset */
  height:          ${props =>
    props.$height != null ? toPx(props.$height) : sizeStyles[props.$size || "default"].height};

  width: ${props =>
    props.$width != null ? toPx(props.$width) : sizeStyles[props.$size || "default"].w$width};

  /* size presets */
  padding: ${props => sizeStyles[props.$size || "default"].padding};
  font-size: ${props => sizeStyles[props.$size || "default"].fontSize};

  /* pointer feedback while loading */
  cursor: ${props => (props.$loading ? "progress" : "pointer")};

  &[aria-busy="true"] {
    opacity: 0.55;
    cursor: progress;
  }

  &:disabled:not([aria-busy="true"]) {
    background-color: var(--MIST, #f7f8f9);
    color: var(--character-disabled-placeholder-25, rgba(0, 0, 0, 0.25));
    cursor: not-allowed;
  }
`;

export const StyledIconButton = styled.button`
  background: none;
  border: none;

  &.primary {
    color: var(--Primary-Blue, #2060ea);
    font-weight: 500;
    padding: 0;
  }
`;

export const IconWithNameSpan = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
`;
